import { useFormSettingsContext } from '#apps/client-web/features/settings/providers/form-settings-provider';

export const useFormDescriptions = <T extends Partial<Record<string, string>>>(
  descriptions: T,
) => {
  const { showFieldDescriptions } = useFormSettingsContext();
  return (fieldPath: keyof T): string | undefined =>
    showFieldDescriptions ? descriptions[fieldPath] : undefined;
};
